import { Route, Routes, Outlet } from 'react-router-dom'
import { UsuariosListWrapper } from './usuarios-list/UsuariosList'
import { PageTitle } from '_metronic/layout/core'
import { useT } from '_metronic/i18n/Metronici18n'

const UsuariosPage = () => {
  const { t } = useT()
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path=''
          element={
            <>
              <PageTitle description={t('pagina.usuarios.descricao')}>
                {t('menu.usuarios')}
              </PageTitle>
              <UsuariosListWrapper />
            </>
          }
        />
      </Route>
    </Routes>
  )
}

export default UsuariosPage
